import { PromptTemplateCategory } from '../types';

export const professional: PromptTemplateCategory = {
  title: "Professionale",
  icon: "💼",
  templates: [
    {
      title: "Script YouTube / Video",
      content: `Scrivi uno script per un video YouTube narrato da una sola persona.
- L'argomento del video è [5 errori comuni nel lavoro da casa — e come correggerli].
- Pubblico target: [giovani professionisti che iniziano il loro primo lavoro da remoto].
- Tono: [amichevole, conversazionale e pratico — come consigli da un collega fidato].
- Struttura con un gancio forte nelle prime due frasi, transizioni chiare tra i punti e una chiusura breve con invito all'azione.
- Scrivi per la comunicazione orale: usa paragrafi brevi e domande retoriche per mantenere l'attenzione dell'ascoltatore.`
    },
    {
      title: "Spiegazione Prodotto",
      content: `Scrivi uno script di voiceover per un video esplicativo di prodotto.
- Il prodotto è [un'app mobile che aiuta i piccoli imprenditori a tracciare le spese scansionando gli scontrini].
- Pubblico target: [freelancer e piccoli imprenditori che odiano la contabilità].
- Vantaggi chiave da evidenziare:
  1. [Scansiona uno scontrino in 2 secondi — nessun inserimento manuale].
  2. [Categorie di spesa automatiche con suggerimenti intelligenti].
  3. [Esportazione con un tocco per la stagione fiscale].
- Tono: [chiaro, vivace e rassicurante — questo rende facile un compito doloroso].
- Mantieni le frasi concise e incisive. Evita il gergo.`
    },
    {
      title: "Discorso di Presentazione",
      content: `Scrivi un discorso per una presentazione professionale o keynote.
- L'occasione è [una riunione aziendale per lanciare un nuovo trimestre].
- L'oratore è [un team leader che si rivolge a un pubblico misto di ingegneri, designer e manager].
- Messaggio centrale: [celebrare i successi del trimestre passato, riconoscere onestamente le sfide e unire il team attorno a un focus chiaro per i mesi a venire].
- Tono: [sicuro, genuino e motivante — niente linguaggio aziendale vuoto].
- Durata parlata approssimativa: [4 minuti].
- Usa espressioni colloquiali, pause strategiche e una frase finale memorabile.`
    }
  ]
};
